import { AlpineComponent } from 'alpinejs';
import Swiper from 'swiper';
import { Autoplay, Navigation } from 'swiper/modules';

interface LogowallOptions {
  autoplay: boolean,
  autoplay_delay: number,
  interaction_stop: boolean,
}

type LogowallData = {}

export default (options: LogowallOptions):AlpineComponent<LogowallData> => ({
  init() {
    const swiperEl = this.$root.querySelector('.swiper') as HTMLElement;
    let autoplayOptions = {};

    if (!swiperEl) {
      return;
    }

    if (options.autoplay) {
      autoplayOptions = {
        delay: options.autoplay_delay,
        disableOnInteraction: options.interaction_stop
      };
    } else {
      autoplayOptions = false;
    }

    new Swiper(swiperEl, {
      autoplay: autoplayOptions,
      speed: 1000,
      loop: true,
      slidesPerView: 1,
      spaceBetween: 0,
      threshold: 10,
      centerInsufficientSlides: true,
      watchOverflow: true,
      followFinger: true,
      updateOnWindowResize: true,
      modules: [Autoplay, Navigation],
      navigation: {
        prevEl: this.$root.querySelector('.ce-logowall-btn--prev') as HTMLElement,
        nextEl: this.$root.querySelector('.ce-logowall-btn--next') as HTMLElement,
      },
      breakpoints: {
        576: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 4,
        },
        1280: {
          slidesPerView: 6,
        },
      },
      on: {
        slidesLengthChange: (swiper) => {
          this.$lazyLoad.update();

          if (this.$cookies) {
            this.$cookies.run(swiper.el);
          }
        },
      }
    });
  },
});
